import React from 'react';
import { Linking, Platform, StyleSheet, View } from 'react-native';
import FontAwesome6 from '@expo/vector-icons/FontAwesome6';
import PropTypes from 'prop-types';
import IconButton from '../../common/IconButton';

export const Socials = ({ facebookLink, instagramLink, isMobile, twitterLink, youtubeLink }) => {
    const renderIcon = (type, link, color, size) => {
        const icon = <FontAwesome6 color={color} name={type} size={Platform.OS.equals('web') ? `${size}pt` : size} style={Styles.icon} />;

        return <IconButton icon={icon} onPress={() => link && Linking.openURL(link)} style={Styles.iconButton} />;
    };

    return (
        <View style={isMobile ? Styles.containerMobile : Styles.container}>
            {!!facebookLink && renderIcon('facebook', facebookLink.externalUrl, '#3c5a99', 20)}
            {!!twitterLink && renderIcon('x-twitter', twitterLink.externalUrl, '#000', 20)}
            {!!instagramLink && renderIcon('instagram', instagramLink.externalUrl, '#800080', 20)}
            {!!youtubeLink && renderIcon('youtube', youtubeLink.externalUrl, '#ff0000', 20)}
        </View>
    );
};

const Styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'flex-end'
    },
    containerMobile: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        marginBottom: 10
    },
    icon: {
        paddingHorizontal: 2,
        paddingVertical: 0
    },
    iconButton: {
        paddingHorizontal: 20,
        paddingVertical: 0
    }
});

Socials.propTypes = {
    facebookLink: PropTypes.shape({
        externalUrl: PropTypes.string
    }),
    instagramLink: PropTypes.shape({
        externalUrl: PropTypes.string
    }),
    isMobile: PropTypes.bool,
    twitterLink: PropTypes.shape({
        externalUrl: PropTypes.string
    }),
    youtubeLink: PropTypes.shape({
        externalUrl: PropTypes.string
    })
};
